import { locale } from './locale';

export const environment = {
    production: true,
    locale: locale,
    recaptchaApiKey: '6LcnacwqAAAAAGvBLGAia37ad5l-yHZXUT35Q9Ou',
    gtagApiKey: 'AW-17398146146',
};
